<template>
  <div class="today-alarm" >
    <nk-box-title :icon-class="'iconfont icon-gaojingjilu1'" :title="'当前告警记录'">
      <!-- <div slot="title" class="logo"> -->
      <div slot="title" >
          <!-- 插槽的内容 -->
      </div>
      <div class="content dn-content-bg"  >
        <div class="param-bottom">
            <div class="total xqh zt">
                <div class="title">告警总数</div>
                <div class="centent red">
                    <span  v-if="totalAlarm.nSum===''">-</span>
                    <countTo v-else :startVal="0" :endVal="parseFloat(totalAlarm.nSum)" :decimals="0" :duration="1000"></countTo>
                    <span class="number">次</span>
                </div>
            </div>
            <div class="total xqh zt">
                <div class="title">已处理</div>
                <div class="centent green">
                    <span  v-if="totalAlarm.nDeal===''">-</span>
                    <countTo v-else :startVal="0" :endVal="parseFloat(totalAlarm.nDeal)" :decimals="0" :duration="1000"  ></countTo> 
                    <span class="number">次</span>
                </div>
            </div>
            <div class="total nomar xqh zt">
                <div class="title">未处理</div>
                <div class="centent yello">
                    <span  v-if="totalAlarm.nUndeal===''">-</span>
                    <countTo v-else :startVal="0" :endVal="parseFloat(totalAlarm.nUndeal)" :decimals="0" :duration="1000"></countTo>
                    <span class="number">次</span>
                </div>
            </div>
          
        </div>
      </div>
    </nk-box-title>
  </div>
</template>
<script>
import NkBoxTitle from "@/components/common/NkBoxTitle.vue";
import countTo from "vue-count-to";
import dateTool from '@/utils/dateTool' 
let vm;
export default {
    components: { NkBoxTitle,countTo },
    data() {
        return {
            nUndeal:300,
            totalAlarm:{},
            time:60,
            interTime:null,
        };
    },
    created() {
        vm=this
        vm.getData()
    },
    mounted() {
    },
    methods: {
        getData(){
            let vm = this
            let time = new Date()
            let startTime = dateTool.format(time, 'yyyy-MM-dd ') + '00:00:00'
            time.setDate(time.getDate() + 1)
            let endTime = dateTool.format(time, 'yyyy-MM-dd') + ' 00:00:00'
            vm.$api.puzzle.puzzleEventSummationInfo(startTime, endTime).then(res=>{
                if(res.success){
                    vm.totalAlarm= res.data
                    if(vm.interTime){
                        clearTimeout(vm.interTime);
                    }
                    if(vm.time > 0){
                        vm.interTime = setTimeout(() => {
                            vm.getData()
                        }, vm.time * 1000);
                    }
                }else{
                    vm.$message.error(res.msg)
                }
            }).catch(error=>{
                vm.$messge.error(error.msg)
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.spanColor{
    color: rgba(242, 178, 54);
}
.today-alarm {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
  .logo {
    line-height: 25px;
    display: flex;
    flex-flow: row;
    color: rgba(30, 30, 30);
    margin-left: 5px;
    .logoImg {
      margin-right: 5px;
    }
  }
  .content {
    display: flex;
    flex: 1;
    flex-flow: column;
    // margin: 0 8px;
    padding: 0 8px;
    box-sizing: border-box;
    color: #181818;
    .param-top {
        height: 30px;
        line-height:30px;
        .ico-box{
            height: 25px;
            line-height: 25px;
            font-size: 12px;
            text-align: left;
            color: rgba(104, 104, 104);
            padding: 7px 0;
            box-sizing: border-box;
            .time{
                margin-left: 5px;
                color:rgba(107, 186, 245)
            }
        }
    }
    .param-bottom {
        display: flex;
        flex: 1;
        flex-flow: row;
        margin-bottom: 8px;
        margin-top:8px;
        .total{
            display: flex;
            flex: 1;
            flex-flow: column;
            margin-right: 8px;
            .title{
                display: flex;
                flex: 3;
                justify-content: center;
                align-items: center;
                font-weight: 600;
            }
            .centent{
                display: flex;
                flex: 2;
                justify-content: center;
                align-items: center;
                // background: rgba(1, 151, 238);
                font-size: 36px;
                border-radius: 3px;
                .number{
                    margin-left: 5px;
                    font-size: 12px;
                    padding-top: 7px;
                    box-sizing: border-box;
                }
            }
        }
        .nomar{
            margin-right: 0;
        }
    }
  }
}
</style>
